import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50cd4f3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-sm" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "font-bold text-lg" }
const _hoisted_4 = { class: "text-sm font-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-light text-gray-500" }, "Follower details loading...", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "font-bold text-lg" }
const _hoisted_9 = { class: "text-sm font-bold" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "pb-3" }
const _hoisted_12 = { class: "clear-both font-bold text-lg" }
const _hoisted_13 = { class: "text-sm font-bold" }
const _hoisted_14 = { class: "text-sm font-light text-gray-500" }
const _hoisted_15 = { class: "text-sm font-light" }
const _hoisted_16 = { class: "text-blue-50 whitespace-pre" }
const _hoisted_17 = { class: "whitespace-pre" }
const _hoisted_18 = { class: "text-blue-50 whitespace-pre" }
const _hoisted_19 = {
  key: 2,
  class: "text-sm font-light pb-3"
}
const _hoisted_20 = { class: "text-blue-50 whitespace-pre" }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { class: "text-blue-50 whitespace-pre" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_manage_follow = _resolveComponent("manage-follow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.followQueryLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, "@" + _toDisplayString(_ctx.user.username), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
          _hoisted_5
        ]))
      : (_ctx.followDetails?.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.currentUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
                  _createElementVNode("p", _hoisted_9, "@" + _toDisplayString(_ctx.user.username), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_manage_follow, {
                      id: _ctx.user.id,
                      type: "User",
                      following: _ctx.followDetails,
                      onUpdated: _ctx.refetch
                    }, null, 8, ["id", "following", "onUpdated"]),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
                  ]),
                  _createElementVNode("span", _hoisted_13, "@" + _toDisplayString(_ctx.user.username), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.followDetails.followingYou ? ' Follows You' : ''), 1)
                ])),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", null, _toDisplayString(_ctx.followDetails.userFollowsCount), 1),
              _createElementVNode("span", _hoisted_16, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showUser('/following')))
                }, " Following ")
              ]),
              _createElementVNode("span", _hoisted_17, _toDisplayString('  ' + _ctx.followDetails.userFollowedByCount), 1),
              _createElementVNode("span", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showUser('/followers')))
                }, " Followers ")
              ])
            ]),
            (_ctx.currentUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.followDetails.playlistCount), 1),
                  _createElementVNode("span", _hoisted_20, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showUser('/playlists')))
                    }, " Collections ")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.followDetails.publishedPlaylistCount), 1),
                  _createElementVNode("span", _hoisted_22, [
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showUser('/playlists')))
                    }, " Published Collections ")
                  ])
                ]))
          ]))
        : _createCommentVNode("", true)
  ]))
}